/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesUpdate } from "../funcs/riskPoliciesUpdate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskPolicy } from "../models/components/riskpolicy.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateRiskPolicyRequest,
  UpdateRiskPolicySecurity,
} from "../models/operations/updateriskpolicy.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskPoliciesUpdateMutationVariables = {
  request: UpdateRiskPolicyRequest;
  security?: UpdateRiskPolicySecurity | undefined;
  options?: RequestOptions;
};

export type RiskPoliciesUpdateMutationData = RiskPolicy;

export type RiskPoliciesUpdateMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateRiskPolicy risk
 *
 * @remarks
 * Update a risk analysis policy.
 */
export function useRiskPoliciesUpdateMutation(
  options?: MutationHookOptions<
    RiskPoliciesUpdateMutationData,
    RiskPoliciesUpdateMutationError,
    RiskPoliciesUpdateMutationVariables
  >,
): UseMutationResult<
  RiskPoliciesUpdateMutationData,
  RiskPoliciesUpdateMutationError,
  RiskPoliciesUpdateMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskPoliciesUpdateMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskPoliciesUpdate(): MutationKey {
  return ["@gram/client", "policies", "update"];
}

export function buildRiskPoliciesUpdateMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskPoliciesUpdateMutationVariables,
  ) => Promise<RiskPoliciesUpdateMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskPoliciesUpdate(),
    mutationFn: function riskPoliciesUpdateMutationFn({
      request,
      security,
      options,
    }): Promise<RiskPoliciesUpdateMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskPoliciesUpdate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
